module.exports = __webpack_public_path__ + "img/dvv-vertical.95c56d5f.png";